// extracted by mini-css-extract-plugin
export var fullHeightState = "_2i-7";
export var headerCell = "_2i-1";
export var loadingStateCell = "_2i-4";
export var rowWrapper = "_2i-3";
export var standaloneTable = "_2i-8";
export var standaloneTableWithBodyFill = "_2i-9";
export var stateCell = "_2i-5";
export var table = "_2i-0";
export var tableBodyFiller = "_2i-6";
export var white = "_2i-2";